export default __webpack_public_path__ + "static/media/fixedIcon.8a80651f.svg";